import ApplicationController from './application_controller';

/**
 * Handles social media sharing for referral links
 *
 * @example
 * <div data-controller="referral-share">
 *   <select data-action="change->referral-share#selectProduct">
 *     <option value="url1" data-text="text1">Option 1</option>
 *   </select>
 *   <button data-action="referral-share#shareTwitter">Share on Twitter</button>
 *   <button data-action="referral-share#shareFacebook">Share on Facebook</button>
 *   <button data-action="referral-share#shareLinkedIn">Share on LinkedIn</button>
 * </div>
 */

export default class extends ApplicationController {
  connect() {
    // Initialize with first option
    const select = this.element.querySelector('select');
    if (select) {
      this.updateFromSelect(select);
    }
  }

  selectProduct(event) {
    this.updateFromSelect(event.target);
  }

  updateFromSelect(select) {
    const selectedOption = select.options[select.selectedIndex];
    this.selectedUrl = selectedOption.value;
    this.selectedText = selectedOption.dataset.text || 'Check out Ambiki!';
  }

  shareTwitter(event) {
    event.preventDefault();

    const text = this.selectedText || 'Check out Ambiki!';
    const url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(this.selectedUrl)}`;

    this.openPopup(url, 'Twitter Share', 550, 400);
  }

  shareFacebook(event) {
    event.preventDefault();

    const url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(this.selectedUrl)}`;

    this.openPopup(url, 'Facebook Share', 550, 400);
  }

  shareLinkedIn(event) {
    event.preventDefault();

    const url = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(this.selectedUrl)}`;

    this.openPopup(url, 'LinkedIn Share', 550, 400);
  }

  openPopup(url, title, width, height) {
    const left = (screen.width / 2) - (width / 2);
    const top = (screen.height / 2) - (height / 2);
    const features = `width=${width},height=${height},left=${left},top=${top},toolbar=0,status=0,scrollbars=1,resizable=1`;

    window.open(url, title, features);
  }
}
